import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { LoginRes } from '@/api/login'

// 尝试从 localStorage 获取初始值
const getInitialUser = (): LoginRes['data'] | null => {
  try {
    const userStr = localStorage.getItem('user')
    return userStr ? JSON.parse(userStr) : null
  } catch (error) {
    console.error('Failed to parse user from localStorage', error)
    return null
  }
}

interface UserState {
  user: LoginRes['data'] | null
  setUser: (user: LoginRes['data']) => void
  logout: () => void
}

export const useUserStore = create<UserState>()(
  devtools(
    immer((set) => ({
      user: getInitialUser(),
      setUser: (user) => {
        localStorage.setItem('user', JSON.stringify(user))
        set((state) => {
          state.user = user
        })
      },
      logout: () => {
        set((state) => {
          state.user = null
        })
      }
    })),
    { name: 'user-store' }
  )
)
